import { FUNCTIONS_ENDPOINT } from 'constants/functions'
import { TOKEN_MODEL_KEY } from 'models/daos/token/constants'
import { API_METHOD } from 'modules/api/constants'
import {
  CREDENTIAL_DOMAIN,
  CREDENTIAL_KEY,
  CREDENTIAL_STATE
} from 'modules/credential/constants'
import { saveLegacyReduxAction } from 'modules/redux/actions/legacy/save'
import { updateLegacyReduxAction } from 'modules/redux/actions/legacy/update'
import {
  validateLegacyReduxAction,
  validationErrorLegacyReduxAction
} from 'modules/redux/actions/legacy/validate'
import REDUX_OPTION from 'modules/redux/constants/option'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { getTokenSelector } from 'modules/tokens/selectors'
import { TRAINING_ENDPOINT } from 'modules/training/constants'
import setUtil from 'utils/set'
import { getObjectUtil } from 'packages/src'

/**
 * Init the given key to an empty string.
 * @param  {String[]} keys
 * @returns {Function}
 */
function initCredentialAction (keys) {
  return (dispatch, getState) => {
    const path = CREDENTIAL_DOMAIN
    let value = getObjectUtil(getState(), path)
    const newValues = keys.reduce((obj, key) => {
      obj[key] = ''
      return obj
    }, {})
    value = setUtil(value, 'changed', newValues)
    dispatch(
      updateLegacyReduxAction({
        path,
        value
      })
    )
    dispatch(
      validateCredentialAction()
    )
  }
}

/**
 * Update the current's user property.
 * @param  {string} key
 * @param  {*} value
 * @returns {Function}
 */
function updateCredentialAction (key, value) {
  return dispatch => {
    dispatch(
      updateLegacyReduxAction({
        path: CREDENTIAL_DOMAIN,
        key,
        value,
        options: {
          [REDUX_OPTION.OMIT_EDITING]: true
        }
      })
    )
    dispatch(
      validateCredentialAction()
    )
  }
}

/**
 * Resets the credential to its initial state.
 * @returns {Function}
 */
function resetCredentialAction () {
  return updateLegacyReduxAction({
    path: CREDENTIAL_DOMAIN,
    value: CREDENTIAL_STATE
  })
}

/**
 * Resets the credential to its initial state.
 * @returns {Function}
 */
function validateCredentialAction () {
  return validateLegacyReduxAction(CREDENTIAL_DOMAIN, {
    [REDUX_OPTION.SHOULD_HIDE_BANNER]: true
  })
}

/**
 * Sends the email to the remote api.
 * @returns {Function}
 */
function resetPasswordCredentialAction () {
  return (dispatch, getState) => {
    const path = CREDENTIAL_DOMAIN
    const value = getObjectUtil(getState(), path)
    const endpoint = FUNCTIONS_ENDPOINT.RESET_PASSWORD
    const data = {
      email: value.changed[CREDENTIAL_KEY.EMAIL]
    }
    const promise = dispatch(
      saveLegacyReduxAction({
        data,
        endpoint,
        method: API_METHOD.POST,
        path
      })
    )
    if (promise) {
      promise.catch(error => {
        console.error('[resetPasswordCredentialAction] failed: ', error)
      })
    }
    return promise
  }
}

/**
 * Changes the user's password.
 * @param   {Object} options
 *          {boolean} options.isApp
 * @returns {Function}
 */
function changePasswordCredentialAction (options) {
  return (dispatch, getState) => {
    // Get the Credential
    const path = CREDENTIAL_DOMAIN
    const value = getObjectUtil(getState(), path)
    // If the password are not the same, trigger an error
    if (
      value.changed[CREDENTIAL_KEY.NEW_PASSWORD] !==
      value.changed[CREDENTIAL_KEY.CONFIRM_NEW_PASSWORD]
    ) {
      // TODO create `createValidationObject`
      const validation = {
        key: CREDENTIAL_KEY.CONFIRM_NEW_PASSWORD,
        value: 'Password are not the same'
      }
      dispatch(
        validationErrorLegacyReduxAction(path, validation)
      )
      return
    }
    const data = {
      password: value.changed[CREDENTIAL_KEY.NEW_PASSWORD],
      token: getObjectUtil(getTokenSelector()(getState()), 'data.value')
    }
    const { isApp } = options
    let endpoint
    let remoteUrl
    if (isApp) {
      endpoint = TRAINING_ENDPOINT.CHANGE_PASSWORD
      remoteUrl = TRAINING_API_ENDPOINT
    } else {
      endpoint = FUNCTIONS_ENDPOINT.CHANGE_PASSWORD
      remoteUrl = API_ENDPOINT
    }
    const promise = dispatch(
      saveLegacyReduxAction({
        method: API_METHOD.POST,
        data,
        endpoint,
        remoteUrl,
        path
      })
    )
    if (promise) {
      promise.catch(error => {
        console.error('changePasswordCredentialAction: [ERROR] ', error)
      })
    }
    return promise
  }
}

/**
 * Verifies the email.
 * @param   {Object} options
 *          {boolean} options.isApp
 * @returns {Function}
 */
function verifyEmailCredentialAction (options) {
  return (dispatch, getState) => {
    const data = {
      token: getValueReduxUtil(
        getTokenSelector()(getState()),
        TOKEN_MODEL_KEY.VALUE
      )
    }
    const { isApp } = options
    let endpoint
    let remoteUrl
    if (isApp) {
      endpoint = TRAINING_ENDPOINT.VERIFY_EMAIL
      remoteUrl = TRAINING_API_ENDPOINT
    } else {
      endpoint = FUNCTIONS_ENDPOINT.VERIFY_EMAIL
      remoteUrl = API_ENDPOINT
    }
    return dispatch(
      saveLegacyReduxAction({
        method: API_METHOD.POST,
        data,
        endpoint,
        remoteUrl,
        path: CREDENTIAL_DOMAIN
      })
    )
  }
}

export {
  initCredentialAction,
  updateCredentialAction,
  resetCredentialAction,
  resetPasswordCredentialAction,
  changePasswordCredentialAction,
  verifyEmailCredentialAction
}
